/* soraflo-push: 2026-07-09T06:27:52.225Z */
/**
 * Vehicle Fitment Badge — SoraFlo
 *
 * Reads the shopper's saved vehicle from localStorage (written by
 * vehicle-filter.js) and renders a fit / no-fit / no-vehicle badge
 * on product pages. No API call required — product fitment data is
 * embedded by the Liquid block into data attributes.
 */

(function () {
  "use strict";

  // ── Parse a JSON array from a data attribute ───────────────────────────────
  // dataset values are already HTML-entity decoded by the browser.

  function parseJsonAttr(val) {
    if (!val || val === "null" || val === "undefined") return [];
    try {
      var parsed = JSON.parse(val);
      return Array.isArray(parsed) ? parsed : [];
    } catch (e) {
      return [];
    }
  }

  // ── Load the saved vehicle from localStorage ───────────────────────────────

  function loadVehicle(shopDomain, namespace) {
    var key = "vff_" + shopDomain + "_" + namespace;
    try {
      var raw = localStorage.getItem(key);
      return raw ? JSON.parse(raw) : null;
    } catch (e) {
      return null;
    }
  }

  // ── Determine fit state ─────────────────────────────────────────────────────
  // Returns: 'fits' | 'no-fit' | 'no-vehicle'

  function fitState(vehicle, makes, models) {
    if (!vehicle || !vehicle.make) return "no-vehicle";

    var savedMake  = vehicle.make;
    var savedModel = vehicle.model || "";

    // Exact match in the product's makes list
    var hasMake = makes.indexOf(savedMake) !== -1;
    if (!hasMake) return "no-fit";

    // If no model was selected or the product has no model list, make match is enough
    if (!savedModel || models.length === 0) return "fits";

    var hasModel = models.indexOf(savedModel) !== -1;
    return hasModel ? "fits" : "no-fit";
  }

  // ── SVG icons ──────────────────────────────────────────────────────────────

  function checkSvg() {
    var svg = document.createElementNS("http://www.w3.org/2000/svg", "svg");
    svg.setAttribute("viewBox",  "0 0 24 24");
    svg.setAttribute("width",    "16");
    svg.setAttribute("height",   "16");
    svg.setAttribute("fill",     "none");
    svg.setAttribute("stroke",   "currentColor");
    svg.setAttribute("stroke-width",    "2.5");
    svg.setAttribute("stroke-linecap",  "round");
    svg.setAttribute("stroke-linejoin", "round");
    svg.setAttribute("aria-hidden",     "true");
    var p = document.createElementNS("http://www.w3.org/2000/svg", "path");
    p.setAttribute("d", "M20 6L9 17l-5-5");
    svg.appendChild(p);
    return svg;
  }

  function crossSvg() {
    var svg = document.createElementNS("http://www.w3.org/2000/svg", "svg");
    svg.setAttribute("viewBox",  "0 0 24 24");
    svg.setAttribute("width",    "16");
    svg.setAttribute("height",   "16");
    svg.setAttribute("fill",     "none");
    svg.setAttribute("stroke",   "currentColor");
    svg.setAttribute("stroke-width",    "2.5");
    svg.setAttribute("stroke-linecap",  "round");
    svg.setAttribute("stroke-linejoin", "round");
    svg.setAttribute("aria-hidden",     "true");
    var l1 = document.createElementNS("http://www.w3.org/2000/svg", "line");
    l1.setAttribute("x1", "18"); l1.setAttribute("y1", "6");
    l1.setAttribute("x2", "6");  l1.setAttribute("y2", "18");
    var l2 = document.createElementNS("http://www.w3.org/2000/svg", "line");
    l2.setAttribute("x1", "6");  l2.setAttribute("y1", "6");
    l2.setAttribute("x2", "18"); l2.setAttribute("y2", "18");
    svg.appendChild(l1);
    svg.appendChild(l2);
    return svg;
  }

  function truckSvg() {
    var svg = document.createElementNS("http://www.w3.org/2000/svg", "svg");
    svg.setAttribute("viewBox",         "0 0 512 512");
    svg.setAttribute("width",           "16");
    svg.setAttribute("height",          "16");
    svg.setAttribute("fill",            "none");
    svg.setAttribute("stroke",          "currentColor");
    svg.setAttribute("stroke-width",    "32");
    svg.setAttribute("stroke-linecap",  "round");
    svg.setAttribute("stroke-linejoin", "round");
    svg.setAttribute("aria-hidden",     "true");
    var body = document.createElementNS("http://www.w3.org/2000/svg", "rect");
    body.setAttribute("x", "32"); body.setAttribute("y", "176");
    body.setAttribute("width", "288"); body.setAttribute("height", "160");
    body.setAttribute("rx", "16");
    var cab = document.createElementNS("http://www.w3.org/2000/svg", "path");
    cab.setAttribute("d", "M320 208h80l48 96v32H320V208z");
    var w1 = document.createElementNS("http://www.w3.org/2000/svg", "circle");
    w1.setAttribute("cx", "112"); w1.setAttribute("cy", "368"); w1.setAttribute("r", "36");
    var w2 = document.createElementNS("http://www.w3.org/2000/svg", "circle");
    w2.setAttribute("cx", "368"); w2.setAttribute("cy", "368"); w2.setAttribute("r", "36");
    svg.appendChild(body);
    svg.appendChild(cab);
    svg.appendChild(w1);
    svg.appendChild(w2);
    return svg;
  }

  function wheelSvg() {
    var svg = document.createElementNS("http://www.w3.org/2000/svg", "svg");
    svg.setAttribute("viewBox",         "0 0 24 24");
    svg.setAttribute("width",           "16");
    svg.setAttribute("height",          "16");
    svg.setAttribute("fill",            "none");
    svg.setAttribute("stroke",          "currentColor");
    svg.setAttribute("stroke-width",    "2");
    svg.setAttribute("stroke-linecap",  "round");
    svg.setAttribute("stroke-linejoin", "round");
    svg.setAttribute("aria-hidden",     "true");
    var outer = document.createElementNS("http://www.w3.org/2000/svg", "circle");
    outer.setAttribute("cx", "12"); outer.setAttribute("cy", "12"); outer.setAttribute("r", "10");
    var hub = document.createElementNS("http://www.w3.org/2000/svg", "circle");
    hub.setAttribute("cx", "12"); hub.setAttribute("cy", "12"); hub.setAttribute("r", "3");
    var s1 = document.createElementNS("http://www.w3.org/2000/svg", "line");
    s1.setAttribute("x1","12"); s1.setAttribute("y1","2"); s1.setAttribute("x2","12"); s1.setAttribute("y2","9");
    var s2 = document.createElementNS("http://www.w3.org/2000/svg", "line");
    s2.setAttribute("x1","12"); s2.setAttribute("y1","15"); s2.setAttribute("x2","12"); s2.setAttribute("y2","22");
    var s3 = document.createElementNS("http://www.w3.org/2000/svg", "line");
    s3.setAttribute("x1","2"); s3.setAttribute("y1","12"); s3.setAttribute("x2","9"); s3.setAttribute("y2","12");
    var s4 = document.createElementNS("http://www.w3.org/2000/svg", "line");
    s4.setAttribute("x1","15"); s4.setAttribute("y1","12"); s4.setAttribute("x2","22"); s4.setAttribute("y2","12");
    svg.appendChild(outer);
    svg.appendChild(hub);
    svg.appendChild(s1);
    svg.appendChild(s2);
    svg.appendChild(s3);
    svg.appendChild(s4);
    return svg;
  }

  function iconSvg(name) {
    if (name === "truck")  return truckSvg();
    if (name === "wheel")  return wheelSvg();
    return carSvg();
  }

  function carSvg() {
    var svg = document.createElementNS("http://www.w3.org/2000/svg", "svg");
    svg.setAttribute("viewBox",         "0 0 512 512");
    svg.setAttribute("width",           "16");
    svg.setAttribute("height",          "16");
    svg.setAttribute("fill",            "none");
    svg.setAttribute("stroke",          "currentColor");
    svg.setAttribute("stroke-width",    "32");
    svg.setAttribute("stroke-linecap",  "round");
    svg.setAttribute("stroke-linejoin", "round");
    svg.setAttribute("aria-hidden",     "true");
    var body = document.createElementNS("http://www.w3.org/2000/svg", "path");
    body.setAttribute("d", "M80 224l37.78-88.15C123.93 121.5 139.6 112 157.11 112h197.78c17.51 0 33.18 9.5 39.33 23.85L432 224M80 224h352v144H80zM112 368v32H80v-32M432 368v32h-32v-32");
    var w1 = document.createElementNS("http://www.w3.org/2000/svg", "circle");
    w1.setAttribute("cx", "144"); w1.setAttribute("cy", "288"); w1.setAttribute("r", "16");
    var w2 = document.createElementNS("http://www.w3.org/2000/svg", "circle");
    w2.setAttribute("cx", "368"); w2.setAttribute("cy", "288"); w2.setAttribute("r", "16");
    svg.appendChild(body);
    svg.appendChild(w1);
    svg.appendChild(w2);
    return svg;
  }

  // ── Build a .vfb-content + optional .vfb-pill structure ───────────────────

  function makeContent(svg, labelEl) {
    var iconWrap = document.createElement("div");
    iconWrap.className = "vfb-icon-circle";
    iconWrap.appendChild(svg);

    var content = document.createElement("div");
    content.className = "vfb-content";
    content.appendChild(iconWrap);
    content.appendChild(labelEl);
    return content;
  }

  function makePill(text) {
    var pill = document.createElement("span");
    pill.className = "vfb-pill";
    pill.textContent = text;
    return pill;
  }

  // ── Render badge into .vfb-inner ───────────────────────────────────────────

  function render(inner, state, vehicle, collectionUrl, noVehicleLabel, icon) {
    inner.innerHTML = "";
    inner.classList.remove("vfb-loading", "vfb-fits", "vfb-no-fit", "vfb-no-vehicle");
    noVehicleLabel = noVehicleLabel || "Select your vehicle to check fitment";
    icon = icon || "car";

    if (state === "fits") {
      var label = vehicle.model || vehicle.make || "";
      inner.classList.add("vfb-fits");

      var text = document.createElement("span");
      text.className = "vfb-label";
      text.textContent = "Fits your " + label;

      inner.appendChild(makeContent(checkSvg(), text));
      inner.appendChild(makePill("Compatible"));

    } else if (state === "no-fit") {
      var label2 = vehicle.model || vehicle.make || "";
      inner.classList.add("vfb-no-fit");

      var text2 = document.createElement("span");
      text2.className = "vfb-label";
      text2.textContent = "Does not fit your " + label2;

      inner.appendChild(makeContent(crossSvg(), text2));
      inner.appendChild(makePill("Not Compatible"));

    } else {
      // no-vehicle
      inner.classList.add("vfb-no-vehicle");

      // Resolve the "no vehicle" link target.
      // Priority:
      //   1. window.__vffBadgeNoVehicleLink — custom URL set in SoraFlo settings
      //      (injected into theme.liquid on every push). This overrides the
      //      selector anchor so merchants can redirect to a collection page even
      //      when the vehicle selector widget is hidden on the product page.
      //   2. .vff-root present on the page — scroll/anchor to the selector.
      //   3. collectionUrl data attribute — fallback link.
      //   4. Plain label with no interaction.
      var overrideLink = window.__vffBadgeNoVehicleLink || "";
      var selectorRoot = !overrideLink && document.querySelector(".vff-root");

      var labelEl;
      if (overrideLink) {
        labelEl = document.createElement("a");
        labelEl.className = "vfb-label vfb-link";
        labelEl.href = overrideLink;
        labelEl.textContent = noVehicleLabel;
      } else if (selectorRoot) {
        labelEl = document.createElement("button");
        labelEl.type = "button";
        labelEl.className = "vfb-label vfb-link";
        labelEl.textContent = noVehicleLabel;
        labelEl.addEventListener("click", function () {
          selectorRoot.scrollIntoView({ behavior: "smooth", block: "center" });
          // On mobile the selector uses a trigger button to open the panel.
          var mobileTrigger = selectorRoot.querySelector(".vff-mobile-trigger");
          if (mobileTrigger && getComputedStyle(mobileTrigger).display !== "none") {
            mobileTrigger.click();
          }
        });
      } else if (collectionUrl) {
        labelEl = document.createElement("a");
        labelEl.className = "vfb-label vfb-link";
        labelEl.href = collectionUrl;
        labelEl.textContent = noVehicleLabel;
      } else {
        labelEl = document.createElement("span");
        labelEl.className = "vfb-label";
        labelEl.textContent = noVehicleLabel;
      }

      inner.appendChild(makeContent(iconSvg(icon), labelEl));
    }
  }

  // ── Auto-position badge before the add-to-cart button ─────────────────────
  // Called for elements that have the vfb-auto-position class (injected via
  // theme.liquid snippet rather than placed manually as a block).

  function autoPosition(root) {
    if (!root.classList.contains("vfb-auto-position")) return;
    // Selectors tried in order — most reliable first.
    // .product-form__buttons is confirmed present in common themes.
    var anchors = [
      ".product-form__buttons",
      ".product-form__submit",
      ".product__purchase",
      "product-form",
      "form[action='/cart/add'] button[type='submit']",
      "form[action='/cart/add']",
    ];
    for (var i = 0; i < anchors.length; i++) {
      var el = document.querySelector(anchors[i]);
      if (el && el !== root && !el.contains(root) && el.parentNode) {
        el.parentNode.insertBefore(root, el);
        return;
      }
    }
  }

  // ── Init one .vfb-root element ─────────────────────────────────────────────

  function init(root) {
    var ds             = root.dataset;
    var shopDomain     = ds.shop             || "";
    var namespace      = ds.namespace        || "custom";
    var collectionUrl  = ds.collectionUrl    || "";
    // Icon and no-vehicle label.
    // The extension block renders data-icon="car" and
    // data-no-vehicle-label="Select your vehicle to check fitment" from the
    // Shopify schema defaults even when the merchant hasn't customised them and
    // patchSections hasn't updated block.settings.*  Those non-empty default
    // strings would normally shadow the globals we inject via theme.liquid, so
    // we explicitly skip any value that is still the schema default and fall
    // through to the global, then the hard-coded fallback.
    var DEFAULT_NO_VEHICLE = "Select your vehicle to check fitment";
    var DEFAULT_ICON       = "car";

    var rawNoVehicle = ds.noVehicleLabel || "";
    var noVehicleLabel = (rawNoVehicle && rawNoVehicle !== DEFAULT_NO_VEHICLE)
      ? rawNoVehicle
      : (window.__vffBadgeNoVehicleText || DEFAULT_NO_VEHICLE);

    var rawIcon = ds.icon || "";
    var icon = (rawIcon && rawIcon !== DEFAULT_ICON)
      ? rawIcon
      : (window.__vffBadgeIcon || DEFAULT_ICON);
    // Read allowed product types.
    // Priority: data-allowed-types attribute (set by extension block / snippet)
    // then window.__vffBadgeTypes (injected by SoraFlo push into theme.liquid).
    // The global is the most reliable source because it's always current after a push
    // even when block.settings.allowed_product_types wasn't patched in the theme JSON.
    var allowedTypes   = ds.allowedTypes || (window.__vffBadgeTypes || "") || "";
    var productType    = ds.productType      || "";
    var makes          = parseJsonAttr(ds.makes);
    var models         = parseJsonAttr(ds.models);

    // ── JS-level product type filter ──────────────────────────────────────────
    // When data-allowed-types is set (written by SoraFlo push), hide the badge
    // if the current product type is not in the allowed list.
    // This works across all rendering paths (extension block + dispatcher snippet)
    // without requiring Shopify CLI redeploy.
    if (allowedTypes) {
      var typeParts = allowedTypes.split(",");
      var matched = false;
      for (var ti = 0; ti < typeParts.length; ti++) {
        if (typeParts[ti].trim().toLowerCase() === productType.toLowerCase()) {
          matched = true;
          break;
        }
      }
      if (!matched) {
        root.parentNode && root.parentNode.removeChild(root);
        return;
      }
    }

    var inner = root.querySelector(".vfb-inner");
    if (!inner) return;

    // Move the element into position if injected via snippet
    autoPosition(root);

    function update() {
      var vehicle = loadVehicle(shopDomain, namespace);
      var state   = fitState(vehicle, makes, models);
      render(inner, state, vehicle, collectionUrl, noVehicleLabel, icon);
    }

    update();

    var storageKey = "vff_" + shopDomain + "_" + namespace;

    // Cross-tab: fires when another tab writes to localStorage
    window.addEventListener("storage", function (e) {
      if (e.key === storageKey) update();
    });

    // Same-tab: vehicle-filter.js dispatches this after every save/clear
    window.addEventListener("vff:vehicle-change", function (e) {
      if (e.detail && e.detail.storageKey === storageKey) update();
    });
  }

  // ── Boot ───────────────────────────────────────────────────────────────────

  function boot() {
    // Deduplication: multiple sources (dispatcher block, @theme block, theme.liquid
    // snippet) can all render a .vfb-root simultaneously. Keep exactly one:
    //   1. Prefer the first non-auto-position element (block-rendered, positioned
    //      by the merchant in the theme editor).
    //   2. If all are auto-position (fallback mode), keep just the first one.
    // Every other .vfb-root is removed from the DOM before init runs.
    var all = Array.prototype.slice.call(document.querySelectorAll(".vfb-root"));
    if (all.length > 1) {
      var keep = null;
      for (var i = 0; i < all.length; i++) {
        if (!all[i].classList.contains("vfb-auto-position")) { keep = all[i]; break; }
      }
      if (!keep) keep = all[0];
      for (var j = 0; j < all.length; j++) {
        if (all[j] !== keep) {
          all[j].parentNode && all[j].parentNode.removeChild(all[j]);
        }
      }
    }
    document.querySelectorAll(".vfb-root").forEach(init);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }

  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener("shopify:block:select",  function (e) { init(e.target); });
    document.addEventListener("shopify:section:load",  boot);
  }
})();
